import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { getFingerprint } from '@telecom/shared/utils/fingerprint';
import { isUserLogin } from '@telecom/shared/startup/user-auth';
import { OnboardingBrowserRuntimeImpl } from '../../common/services/impls/onboarding-browser-runtime';
import type { FtoProOnboardingRuntime } from '../fto-pro-onboarding-runtime';

/** FTO Pro 首次引导的浏览器 runtime，复用公共 DOM、Driver、存储和定时器能力。 */
@injectable()
export class FtoProOnboardingRuntimeImpl
    extends OnboardingBrowserRuntimeImpl
    implements FtoProOnboardingRuntime {
    /** 获取用于隔离首次展示状态的浏览器稳定指纹。 */
    getIdentityId(): Promise<string> {
        return getFingerprint();
    }

    /** 查询当前用户登录状态。 */
    isUserLogin(): Promise<boolean> {
        return isUserLogin();
    }
}
